
export function createDebugPlugin() {
    return function debugPlugin(component) {
        const originalOnMounted = component.onMounted
        component.onMounted = function() {
            if (component && component.root) {
                component.root._tag = component;
            }
            if (originalOnMounted) {
                originalOnMounted.call(this)
            }
        }
        return component
    }
}

export const debugPlugin = createDebugPlugin();
